<template>
  <main :class="tplHidden ? 'tplHidden' : ''">
    <section class="fk-contents">
      <h2 class="title-lv2 mb15">{{getSelectItem.item.category_name}}<br>{{$t('SetMenuList.heading')}}</h2>
      <div class="mod-item-box">
        <div class="item-image"><img :src="getSelectItem.item.image_url" :alt="getSelectItem.item ? getSelectItem.item.category_name : null"></div>
        <div class="item-price">
          <small>{{$t('General.Single')}}</small>
          <strong>¥{{displayThousandsSeparator(getSelectItem.item.price)}}</strong>
          <small>{{getTaxDisplay(getSelectItem.item.tax_type)}}</small>
        </div>
      </div>
      <ul class="select-set-menu-list">
        <li v-for="(item, index) in setMenuList" :key="index">
          <a href="#" @click.prevent="executeSelect($event, item.category_cd)" v-if="item.item_type===2">
            <h3><span v-html="displayCategoryName(item.category_name)"></span><br>＋{{displayThousandsSeparator(displayDifference(item.price, item.item_type))}}{{$t('General.Yen')}}</h3>
            <div class="menu-image"><img :src="item.image_url" :alt="item.category_name"></div>
          </a>
          <a href="#" @click.prevent="executeSelect($event, item.category_cd)" v-if="item.item_type===1">
            <h3>{{$t('General.Single')}}</h3>
            <div class="menu-image"><img :src="item.image_url" :alt="item.category_name"></div>
          </a>
        </li>
      </ul>
    </section>
  </main>
</template>

<script>
import CommonMixin from '@/mixins/CommonMixin'
import AddSingleItemMixin from '@/mixins/AddSingleItemMixin'
import DisplayErrorMixin from '@/mixins/DisplayErrorMixin'
export default {
  name: 'FKMOSetMenuList',
  mixins: [ CommonMixin, AddSingleItemMixin, DisplayErrorMixin ],
  data () {
    return {
      setMenuList: [],
      singlePrice: 0,
      tplHidden: true
    }
  },
  computed: {
    getServerTime () {
      return this.$store.getters.serverTime
    },
    getSelectItem () {
      return this.$store.getters.selectItem
    },
    getReceiveMethod () {
      return Number(this.$store.getters.cart.receive_method)
    },
    getSelectStore () {
      return this.$store.getters.selectStore
    },
    getDisabledButton () {
      return this.$store.getters.disabledButton
    },
    getIsAcceptingMenu () {
      return this.$store.getters.isAcceptingMenu
    }
  },
  methods: {
    executeSelect: function (event, id) {
      if (this.getDisabledButton) {
        return false
      }

      // 選択したセットメニューの詳細をsetmenu_detailsをStoreに書き込む
      const selectItem = {
        coupon: this.getSelectItem.coupon,
        item: this.getSelectItem.item,
        quantity: this.getSelectItem.quantity,
        setmenu: null, // セットメニューの選択状態をリセットする
        setmenu_details: []
      }

      // タップしたボタンのcategory_cdを検索して、select_item.setmenuにセットする
      for (var i in this.setMenuList) {
        if (this.setMenuList[i].category_cd === id) {
          selectItem.setmenu = this.setMenuList[i]
          break
        }
      }
      this.$store.dispatch('setSelectItem', selectItem)

      if (selectItem.setmenu.item_type === 1) {
        // 単品の場合
        this.addSingleItem(selectItem)
      } else if (selectItem.setmenu.item_type === 2) {
        // セットメニューの場合は詳細へ遷移する
        this.$router.push({ name: 'SetMenuDetail' })
      }
    },
    displayDifference: function (num, itemType) {
      // 単品の時はスキップする
      if (itemType === 2) {
        // 単品価格を除いた差額を算出する
        return Number(num) - Number(this.singlePrice)
      }
      return num
    },
    displayCategoryName: function (name) {
      // \r\nが見つけれない場合はそのまま出力する
      if (!name.match(/\r\n/)) {
        return name
      }
      // 文字列を分割する
      let ret = ''
      const strArray = name.split('\r\n')
      if (strArray.length > 0) {
        strArray[0] = `《${strArray[0]}》`
      }
      // 連結する
      for (let i = 0; i < strArray.length; i++) {
        if (i > 0) {
          ret += '<br>'
        }
        ret += strArray[i]
      }
      return ret
    },
    init: function () {
      this.setDisabledButton(true)
      // axios callback内からの参照用
      let that = this
      // typeを決定する
      let type
      if (this.getIsAcceptingMenu.morning) {
        type = 1
      } else if (this.getIsAcceptingMenu.grand) {
        type = 2
      }
      // カテゴリー一覧を取得する
      let params = {
        'store_cd': this.getSelectStore.store_cd,
        type,
        'category_cd': this.getSelectItem.item.category_cd,
        'receive_method': this.getReceiveMethod,
        language: sessionStorage.getItem('lang')
      }
      this.callApi('GetCategoryItem',
        params
      )
      // this.axios.get(`/static/stub/setmenu_list_${this.getSelectItem.item.category_cd}.json`)
        .then(function (res) {
          if (res.data.result) {
            that.setMenuList = res.data.value.category_list
            let selectItem = that.getSelectItem

            // セットメニューリストに1件しかリストが下りてこないため、item_typeを確認して遷移先を振り分ける
            if (that.setMenuList.length === 1) {
              if (that.setMenuList[0].item_type === 1) {
                selectItem.setmenu = that.setMenuList[0]
                that.addSingleItem2(selectItem)
                return
              } else if (that.setMenuList[0].item_type === 2) {
                // セットメニュー詳細に遷移する
                selectItem.setmenu = that.setMenuList[0]
                // 単品価格を取り出す
                selectItem.item.price = that.setMenuList[0].price
                selectItem.item.tax_type = that.setMenuList[0].tax_type
                that.$store.dispatch('setSelectItem', selectItem)
                // (history.back対策)遷移先の履歴に上書きする
                that.$router.replace({ name: 'SetMenuDetail' })
                return
              }
            }

            // テンプレ表示フラグを倒す
            that.tplHidden = false

            // 画像をバインディングする
            for (let i = 0; i < that.setMenuList.length; i++) {
              that.setMenuList[i].image_url = that.importImageUri(that.setMenuList[i].image_url)
            }
            // 単品価格を取得する
            for (let h = 0; h < that.setMenuList.length; h++) {
              if (that.setMenuList[h].item_type === 1) {
                selectItem.item.price = that.setMenuList[h].price
                selectItem.item.tax_type = that.setMenuList[h].tax_type
                that.$store.dispatch('setSelectItem', selectItem)
                // 単品価格を保存する
                that.singlePrice = that.setMenuList[h].price
                break
              }
            }
          } else {
            that.errorFromApi(res.data.errorCode, res.data.error)
          }
        })
        .catch((error) => {
          that.errorFromAxios(error)
        })
        .finally(() => {
          that.setDisabledButton(false)
        })
    }
  },
  beforeMount () {
    // サーバー時間
    this.serverTime = this.getServerTime

    this.init()
  },
  beforeUpdate () {
    this.restoreScaleRate('default') // 拡大縮小のロックを開放
  },
  destroyed () {
    this.restoreScaleRate('reset') // scaleをリセット
  }
}
</script>

<style scoped>
.tplHidden {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SetMenuList.vue